// extracted by mini-css-extract-plugin
export var content = "news-module--content--36af5";
export var image = "news-module--image--3d8a6";
export var news = "news-module--news--eef6c";
export var publicationDate = "news-module--publicationDate--d3308";
export var title = "news-module--title--23822";